<template>
    <div class="row">
        <div class="col-12">
            <div class="card-header-actions">
                <div class="col-lg-8 col-md-8 col-12 card-header-filter-box">
                    <div class="row align-items-end">
                        <div class="col-12 col-sm-4 card-header-select-box pr-sm-2">
                            <div class="form-group">
                                <label>{{$t("realEstate.field.province")}}:</label>
                                <v-select
                                        label="name"
                                        v-model="province"
                                        :filterable="false"
                                        :options="provinces"
                                        @search="onProvinceSearch"
                                        @search:focus="onProvinceFocus"
                                >
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>
                        </div>
                        <div class="col-12 col-sm-4 card-header-select-box px-sm-2">
                            <div class="form-group">
                                <label>{{$t("realEstate.field.region")}}:</label>
                                <v-select
                                        label="name"
                                        v-model="region"
                                        :filterable="false"
                                        :options="regions"
                                        @search="onRegionSearch"
                                        @search:focus="onRegionFocus"
                                >
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>
                        </div>
                        <div class="col-12 col-sm-4">
                            <div v-if="totalValue > 0">Жами ўрта арифметик: <strong>{{totalValue}}</strong></div>
                        </div>
                    </div>
                </div>
                <div class="col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                    <button class="all-btn add-btn m-0" v-if="hasPermission('SETTINGS_BUILDING_CADASTRE_FIX_SIZE_ADD')" @click="showCadastreFixSizeEditModal(null)">{{$t("action.add")}}</button>
                    <button class="all-btn m-0 ml-3" @click="onSearch">
                        <i class="fa fa-search"></i>
                        <span>{{$t('main.search')}}</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
                <table class="table table-sm table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Яратилган сана</th>
                            <th>Яратган фойдаланувчи</th>
                            <th class="text-center">Узгарган сана</th>
                            <th class="text-center">Узгартирган фойдаланувчи</th>
                            <th width="7%">Категория</th>
                            <th class="text-center">Вилоят</th>
                            <th>Туман</th>
                            <th width="7%">Майдони</th>
                            <th width="7%">1м2 нархи</th>
                            <th width="7%" class="text-right">Ўрта арифметик</th>
                            <th width="7%" class="text-right">Улуш</th>
                            <th width="7%" class="text-center">Холати</th>
                            <th width="5%" class="text-center">{{$t("realEstate.field.action")}}</th>
                        </tr>
                    </thead>
                    <tbody v-if="!loading && results && results.data">
                        <template v-for="result in results.data">
                            <tr :key="`first-${result.id}`">
                                <td rowspan="2">{{result.id}}</td>
                                <td rowspan="2">
                                    {{new Date(result.createdDate) | dateFormat('DD.MM.YYYY HH:mm:ss')}}
                                </td>
                                <td rowspan="2">
                                    {{result.createdBy.name}}
                                </td>
                                <td rowspan="2" class="text-right">
                                    <span v-if="result.updatedDate">{{new Date(result.updatedDate) | dateFormat('DD.MM.YYYY HH:mm:ss')}}</span>
                                </td>
                                <td rowspan="2" class="text-right">
                                    <span v-if="result.updatedBy">{{result.updatedBy.name}}</span>
                                </td>
                                <td rowspan="2">
                                    <span class="badge badge-warning">{{result.fixSizeType.name}}</span>
                                </td>
                                <td class="text-center" rowspan="2">{{result.province.name}}</td>
                                <td rowspan="2">
                                    {{result.region.name}}
                                </td>
                                <template v-for="(item,index) in result.items">
                                    <td class="bg-light" :key="`area-${index}`">{{item.area | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                </template>
                                <td></td>
                                <td></td>
                                <td rowspan="2" class="text-center">
                                    <div class="form-group">
                                        <div class="form-check pl-0" v-tooltip="'Фаоллаштириш'">
                                            <label class="form-check-label" style="padding-left:22px !important">
                                                <input class="form-check-input" type="checkbox"
                                                       :disabled="processing"
                                                       v-model="result.active"
                                                       @change="onUpdateActive(result)">
                                                <span class="form-check-sign"></span>
                                            </label>
                                        </div>
                                    </div>
                                </td>
                                <td class="td-actions text-center" rowspan="2">
                                    <button class="all-btn edit-btn table-action" data-original-title="Edit" @click="showCadastreFixSizeEditModal(result)">
                                        <i class="fa fa-edit"></i>
                                    </button>
                                    <button class="all-btn delete-btn table-action"
                                            v-if="hasPermission('NEW_REAL_ESTATE_DELETE')"
                                            v-tooltip="'Ўчириш'"
                                            @click="onDelete(result.id)"
                                    >
                                        <i class="fa fa-remove"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr :key="`second-${result.id}`" class="bg-secondary text-white">
                                <template v-for="(item,index) in result.items">
                                    <td :key="`price-${index}`">{{item.totalPrice | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                </template>
                                <td class="text-right font-weight-bold">{{result.averagePrice | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td class="text-right font-weight-bold">{{result.value}}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <CadastreFixSizeAddModal />
        <CadastreFixSizeEditModal />
    </div>
</template>

<script>

    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import CadastreFixSizeAddModal from '@/views/config/cadastre/CadastreFixSizeAddModal'
    import CadastreFixSizeEditModal from '@/views/config/cadastre/CadastreFixSizeEditModal'
    import initFilterModel from '@/shared/filter';
    export default {
        name: "CadastreFixSizeList",
        components: {
            'b-pagination': bPagination,
            CadastreFixSizeAddModal,
            CadastreFixSizeEditModal
        },
        data() {
            return {
                loading: false,
                processing: false,
                filter: initFilterModel(),
                filterProvince: initFilterModel(),
                filterRegion: initFilterModel(),
                results: null,
                province: null,
                region: null,
                provinces: [],
                regions: [],
                totalValue: 0
            }
        },
        methods: {
            initList(isFilter) {
                this.loading = true;
                this.$http.post('cadastre/fix-size/list', this.filter)
                    .then(res => {
                        let results = res.data;
                        this.results = results;

                        this.totalValue = 0
                        if (isFilter) {
                            if (results && results.data) {
                                let value = 0;
                                results.data.forEach(f => {
                                    if (f.value && f.value > 0) {
                                        value += f.value
                                    }
                                });
                                this.totalValue = value
                            }
                        }
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            showCadastreFixSizeEditModal(data) {
                if (data) {
                    this.$eventBus.$emit('showCadastreFixSizeEditModal', data);
                } else {
                    this.$eventBus.$emit('showCadastreFixSizeAddModal', data);
                }
            },
            onProvinceFocus() {
                this.provinces = [];
                this.filterProvince.search = '';
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onProvinceSearch(searchTxt, loading) {
                loading(true);
                this.provinces = [];
                this.filterProvince.search = searchTxt;
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionSearch(searchTxt, loading) {
                loading(true);
                this.regions = [];
                this.filterRegion.search = searchTxt;
                this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionFocus() {
                this.regions = [];
                this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onSearch() {
                this.filter.provinceId = this.province ? this.province.id : null;
                this.filter.regionId = this.region ? this.region.id : null;
                this.initList(((this.filter.provinceId && this.filter.regionId) ? 'onFilter': null));
            },
            onUpdateActive(data) {
                const vm = this;

                this.processing = true;
                data.value = null
                this.$http.post(`cadastre/fix-size/save-value/${data.id}`, data)
                    .then(res => {
                        const response = res.data;
                        if (response && response.status === 'SUCCESS') {
                            this.initList()
                            vm.processing = false;
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            onDelete(id) {
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('expert2.field.deleteConfirm'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dd3333',
                    confirmButtonText: this.$t('action.delete'),
                    cancelButtonText: this.$t('action.cancel')
                    // cancelButtonColor: '#dd3333'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete('cadastre/fix-size/delete/' + id)
                            .then((res) => {
                                if (res && res.data && res.data.status === 'SUCCESS') {
                                    this.$swal({
                                        title: this.$t('messages.common.success'),
                                        text: this.$t('messages.realEstate.deleteSuccess'),
                                        type: 'success'
                                    });
                                    this.initList();
                                } else {
                                    this.$swal({
                                        title: this.$t('messages.common.warning'),
                                        text: res.data.message,
                                        type: 'warning'
                                    });
                                }
                                this.processing = false;
                            }, () => {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('messages.realEstate.deleteError'),
                                    type: 'error'
                                });
                                this.processing = false;
                            });
                    }
                });
            }
        },
        created() {
            this.filterProvince.page.size = 1000;
            this.filterRegion.page.size = 1000;
            this.initList()
            this.$eventBus.$on('onCadastreFixSizeChanged', () => {
                this.initList(((this.filter.provinceId && this.filter.regionId) ? 'onFilter': null))
            })
        }
    }
</script>

<style scoped>

</style>